import doorEventView from './src/doorEvent/doorEventView.vue'
import doorEquipView from './src/doorEquip/doorEquipView.vue'

let views = {
    doorEventView,
    doorEquipView
};

export default views;
